import { useContext } from "react";

import { useTranslation } from "react-i18next";

import QueryDropdown from "components/QueryDropdown";
import ParamsContext from "context/params/paramsContext";
import { DROPDOWN_SIZES, ID_TYPE, isInternalTypeCompany, Query } from "shared";

import { useDisabledRoleOption } from "../../hooks";
import { RoleProps } from "./types";

const Role = ({
    isLoading,
    roleResource,
    roles,
    companyValue,
    onChange,
    isInvite,
    isReadOnly,
    onInitialOptionsLoad
}: RoleProps) => {
    const { rootCompanyType } = useContext(ParamsContext);

    const { t } = useTranslation();

    const { isDisabledOption, getOptionDisabledTooltip } =
        useDisabledRoleOption(roles, !!isInvite);

    const isRootInternalTypeCompany = isInternalTypeCompany(rootCompanyType);

    return (
        !isRootInternalTypeCompany && (
            <QueryDropdown
                data-testid="roles-dropdown"
                resource={roleResource}
                idType={ID_TYPE.Id}
                isRequired
                multiple
                size={DROPDOWN_SIZES.Medium}
                fullWidth
                value={roles}
                change={(_, val) => onChange(val)}
                onInitialOptionsLoad={onInitialOptionsLoad}
                labelLeft={t("Table##role")}
                textFieldParams={{
                    placeholder:
                        roles.length === 0 ? t("Dialog##assign role") : ""
                }}
                disabled={!isReadOnly && !roleResource}
                getOptionDisabled={(option: Query) => isDisabledOption(option)}
                getOptionDisabledTooltip={(option: Query) =>
                    getOptionDisabledTooltip(option)
                }
                readOnly={isReadOnly ?? isLoading}
                tooltipTitle={
                    companyValue
                        ? undefined
                        : t("Dialog##field disabled until company selected")
                }
                customStyle={{ marginBottom: "16px" }}
            />
        )
    );
};

export { Role };
